import { render, staticRenderFns } from "./ServicePointPage.vue?vue&type=template&id=2ad93d11&scoped=true&"
import script from "./ServicePointPage.vue?vue&type=script&lang=ts&"
export * from "./ServicePointPage.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePointPage.vue?vue&type=style&index=0&id=2ad93d11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad93d11",
  null
  
)

export default component.exports